export enum ZIndex {
  none = 0,
  lowest = 1,
  low = 5,
  medium = 10,
  high = 15,
  highest = 9999,
}
